import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageableResponse } from 'src/@core/interfaces/pageable-response';
import { API_BRIEFING_FORM } from '../util/api.endpoints';

@Injectable({
  providedIn: 'root'
})
export class BrifingFormService {

  constructor(private http: HttpClient) { }

  private getAuthToken(): string | null {
    return localStorage.getItem('jwtToken');
  }

  private getAuthHeaders(): HttpHeaders {
    const token = this.getAuthToken();
    return new HttpHeaders({
      'Authorization': token ? `Bearer ${token}` : '',
      'Content-Type': 'application/json'
    });
  }

  submitBriefingFormWithSection(data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(API_BRIEFING_FORM, data, { headers });
  }

  submitBriefingFormWithOutSection(data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(API_BRIEFING_FORM, data, { headers });
  }

  getBriefingForms(params): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get<any>(API_BRIEFING_FORM, { params });
  }

  getBriefingFormById(id: string): Observable<any> {
    const url = `${API_BRIEFING_FORM}/${id}`;
    return this.http.get<any>(url);
  }

  updateBriefingForm(id: string, data: any): Observable<any> {
    const headers = this.getAuthHeaders();
    const url = `${API_BRIEFING_FORM}/${id}`;
    return this.http.put(url, data, { headers });
  }

  deleteBriefingForm(id: string): Observable<any> {
    const url = `${API_BRIEFING_FORM}/${id}`;
    const headers = this.getAuthHeaders();
    return this.http.delete<any>(url, { headers });
  }
}